import { createFileRoute } from "@tanstack/react-router";
import AdminFeedDownloads from "@/pages/admin/AdminFeedDownloads";

export const Route = createFileRoute("/_adminLayout/admin/feed-downloads")({
  component: AdminFeedDownloads,
});
